import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthorizationService } from './authorization.service';
import { UserService } from './user.service';
import { UserPreference } from '@ng-cloud/badger-core/models/user-preference';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private currentTheme: string;
  private themeSource = new BehaviorSubject<string>('badger-light');
  private userPreference: UserPreference;

  constructor(private authService: AuthorizationService,
              private userService: UserService) {
    this.setCurrentTheme(this.themeSource.value);  //set default to light theme for all apps
    this.authService.getCurrentUser().subscribe(currentUser => {
      this.userService.getUser(currentUser.id).subscribe(user => {
        this.userService.getOrCreateUserPreference(user).subscribe(preference => {
          this.userPreference = preference;
          if(preference.preferences['theme']) {
            this.currentTheme = preference.preferences['theme'];
            this.setCurrentTheme(preference.preferences['theme']);
          }
        });

        this.userService.userPreferences(user.id).subscribe(pref => {
          if (this.userPreference) {
            this.userPreference.preferences = pref.preferences;
          }
          if (pref.preferences && pref.preferences['theme']){
            this.currentTheme = pref.preferences['theme'];
            this.setCurrentTheme(this.currentTheme);
          }
        });
      });
    });
  }

  themes(): Observable<string> {
    return this.themeSource.asObservable();
  }

  getCurrentTheme(): string {
    return this.currentTheme;
  }

  toggleTheme() {
    const userPref = this.userPreference;
    userPref.preferences['theme'] = this.currentTheme === 'badger-light' ? 'badger-dark' : 'badger-light';
    this.userService.updateUserPreference(userPref).subscribe();
  }

  setCurrentTheme(theme: string): void {
    this.currentTheme = theme;
    this.setStyle('theme', `${this.currentTheme}.css`);
    this.themeSource.next(this.currentTheme);
  }

  isDarkTheme(theme: string): boolean {
    return theme && theme.toLowerCase().includes('dark');
  }

  setStyle(key: string, href: string) {
    getLinkElementForKey(key).setAttribute('href', href);
  }
}

function getLinkElementForKey(key: string) {
  return getExistingLinkElementByKey(key) || createLinkElementWithKey(key);
}

function getExistingLinkElementByKey(key: string) {
  return document.head.querySelector(`link[rel="stylesheet"].${getClassNameForKey(key)}`);
}

function createLinkElementWithKey(key: string) {
  const linkEl = document.createElement('link');
  linkEl.setAttribute('rel', 'stylesheet');
  linkEl.classList.add(getClassNameForKey(key));
  document.head.appendChild(linkEl);
  return linkEl;
}

function getClassNameForKey(key: string) {
  return `badger-style-${key}`;
}

